import { getName } from "country-list";
import React from "react";

export const CountriesBadge = ({ countries }) => {
  return (
    <div>
      {countries.map((country_code, index) => (
        <div key={index} className="py-1">
          <span className={`px-2 py-1 rounded text-white text-xs ${country_code === "MX" ? "bg-blue-700" : "bg-orange-500"}`}>
            {country_code ? getName(country_code) : "Unknown"}
          </span>
          <br />
        </div>
      ))}
    </div>
  );
};
